import { render } from "./app-icon-jpg.vue?vue&type=template&id=378043f0"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-jpg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "378043f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('378043f0', __exports__)) {
    console.log('reload')
    api.reload('378043f0', __exports__)
  }
  
  module.hot.accept("./app-icon-jpg.vue?vue&type=template&id=378043f0", () => {
    console.log('re-render')
    api.rerender('378043f0', render)
  })

}


export default __exports__